import Swiper, { Navigation } from 'swiper';
Swiper.use([  Navigation ]);

const dates = document.querySelectorAll('.slider-history__date');
const swiperHistory = new Swiper('.slider-history .swiper', {
	slidesPerView: 'auto',
	watchOverflow: true,
	speed: 800,
	spaceBetween: 24,
	paginationClickable: true,
	navigation: {
		nextEl: '[data-slider-next]',
		prevEl: '[data-slider-prev]',
	},
	grabCursor: true,
	freeMode: false,

	// spaceBetween: 16,
	breakpoints: {
		576: {
			spaceBetween: 32,
		},
		1025: {
			slidesPerView: 1,
			spaceBetween: 40,
		}
	},
});

swiperHistory.on("slideChange", () => {
	dates.forEach((date, index) => {
		date.classList.remove("slider-history__date_active");
		if (index === swiperHistory.activeIndex) {
			date.classList.add("slider-history__date_active");
		}
	})
})
